import { useEffect, useState, useCallback } from "react";
import { Card as BsCard, Row, Col, Table, Container } from "react-bootstrap";
import { getTheLatestDataSentToANA } from "../../services/api";

const ANAInfo = () => {
  const [selfMonitoringData, setSelfMonitoringData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Função para mapear os nomes dos medidores
  const getMedidorName = (intervention) => {
    const pointMap = {
      PRD_013_1: "CAP. PRINCIPAL",
      PRD_013_2: "CAP. G1",
    };
    return pointMap[intervention] || intervention;
  };

  // Função para formatar a data de 2025-10-04T07:15 para 04-10-2025 07:15
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return "-";

    try {
      const date = new Date(dateTimeString);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");

      return `${day}-${month}-${year} ${hours}:${minutes}`;
    } catch (error) {
      //console.error("Erro ao formatar data:", error);
      return dateTimeString;
    }
  };

  const handleGetTheLatestDataSentToANA = useCallback(async () => {
    try {
      //console.log("[ANAInfo] Starting fetch...");
      setIsLoading(true);
      const response = await getTheLatestDataSentToANA();
      //console.log("[ANAInfo] Resposta da API ANA:", {
      //  data: response?.data,
      //  status: response?.status,
      //  statusText: response?.statusText,
      //});
      // Garante que sempre seja um array
      const data = Array.isArray(response?.data) ? response.data : [];
      setSelfMonitoringData(data);
      setIsLoading(false);
    } catch (error) {
      console.error("[ANAInfo] Erro ao buscar dados da ANA:", {
        message: error?.message,
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        data: error?.response?.data,
      });
      setSelfMonitoringData([]); // Garante array vazio em caso de erro
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    //console.log("[ANAInfo] Component mounted, fetching data...");
    handleGetTheLatestDataSentToANA();
    const intervalId = setInterval(
      handleGetTheLatestDataSentToANA,
      1000 * 60 * 30
    ); // 30 minutos

    return () => clearInterval(intervalId);
  }, [handleGetTheLatestDataSentToANA]);

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={7} lg={5}>
          <BsCard bg="light" text="dark" border="info" className="mt-3 shadow">
            <BsCard.Header
              className={`text-bg-info text-center text-white`}
              as="h5"
            >
              <span>Automonitoramento ANA</span>
            </BsCard.Header>

            <BsCard.Body className={`card-body-ana-info fs-7 `}>
              <BsCard.Title>Último envio:</BsCard.Title>
              <Table bordered responsive size="sm">
                <thead>
                  <tr>
                    <th className="text-center">Medidor</th>
                    <th className="text-center">
                      Vazão<span className="text-white">_</span>média (m³/s)
                    </th>
                    <th className="text-center">Volume (m³)</th>
                    <th className="text-center">Horário</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="4" className="text-center text-muted">
                        Carregando dados...
                      </td>
                    </tr>
                  ) : Array.isArray(selfMonitoringData) &&
                    selfMonitoringData.length > 0 ? (
                    selfMonitoringData.map((data, index) => (
                      <tr key={data.intervention || index}>
                        <td className="text-center">
                          {getMedidorName(data.intervention)}
                        </td>
                        <td className="text-center">{data.flow || "-"}</td>
                        <td className="text-center">{data.volume || "-"}</td>
                        <td className="text-center">
                          {formatDateTime(data.time)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-muted">
                        Sem registros
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </BsCard.Body>
          </BsCard>
        </Col>
      </Row>
    </Container>
  );
};

export default ANAInfo;
